import { Component, Input, booleanAttribute } from '@angular/core'

@Component({
    selector: 'app-venue-not-in-service',
    templateUrl: './venue-not-in-service.component.html',
})
export class VenueNotInServiceComponent {
    @Input({ transform: booleanAttribute }) stretch = false
}
